export default __webpack_public_path__ + "static/media/img-buero.2a260adb.png";